// 中英文字段取值混入：英文模式下英文字段为空时，回退读取对应中文字段（中文字段不会为空）
// 用法：localeValue(row, key)，key 为当前语言对应的字段名（如 nameEn），内部自动回退到 nameCh
// el-table-column 可绑定 :formatter="localeFormatter" 实现英文列为空的中文回退
export default {
  methods: {
    localeValue(row, key) {
      if (!row) {
        return '';
      }
      let value = row[key];
      if (this.$i18n && this.$i18n.locale !== 'zh-CN'
          && (value === null || value === undefined || value === '')) {
        value = row[key.replace(/En$/, 'Ch')];
      }
      return value === null || value === undefined ? '' : value;
    },
    // el-table-column formatter：按当前语言取值，英文字段为空时回退中文字段
    localeFormatter(row, column) {
      return this.localeValue(row, column.property);
    },
  },
};
